(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["soi-pdp-buybox"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('soi-product-rating')) {
  customElements.define('soi-product-rating', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.link = this.querySelector('a');
      this.observer = new MutationObserver(() => this.observeRating());
      this.observer.observe(this, { childList: true, subtree: true });
      this.addEventListener('click', event => {
        const target = this.reviewTarget();
        if (!target) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const styles = getComputedStyle(document.documentElement);
        const number = name => parseFloat(styles.getPropertyValue(name)) || 0;
        const offset = number('--header-height') * number('--enable-sticky-header') + number('--announcement-bar-height') * number('--enable-sticky-announcement-bar') + 20;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { capture: true, signal: this.controller.signal });
      customElements.whenDefined('etrusted-star-extension').then(() => {
        if (this.isConnected) this.observeRating();
      });
      this.observeRating();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.shadowObserver?.disconnect();
      this.ratingRoot = null;
    }
    reviewTarget() {
      const widget = document.querySelector('etrusted-widget[data-etrusted-widget-id="wdg-bad08a63-320a-4f95-954e-926b47c48799"]');
      if (!widget) return null;
      const target = widget.closest('.shopify-section') || widget;
      target.id ||= this.link.hash.slice(1);
      this.link.setAttribute('href', `#${target.id}`);
      return target;
    }
    observeRating() {
      const extension = this.querySelector('etrusted-star-extension');
      const root = extension?.shadowRoot;
      if (extension) extension.tabIndex = -1;
      if (root && root !== this.ratingRoot) {
        this.shadowObserver?.disconnect();
        this.ratingRoot = root;
        this.shadowObserver = new MutationObserver(() => this.updateRating());
        this.shadowObserver.observe(root, { childList: true, subtree: true, characterData: true, attributes: true });
      }
      this.updateRating();
    }
    updateRating() {
      const countText = this.ratingRoot?.querySelector('.count')?.textContent || '';
      const count = Number(countText.replace(/[^0-9]/g, ''));
      const grade = this.ratingRoot?.querySelector('.grade')?.textContent.trim();
      this.hidden = !(count > 0 && grade);
      if (!this.hidden) {
        this.link.setAttribute('aria-label', `${grade} / 5 (${count}) – ${this.dataset.label}`);
        this.reviewTarget();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soi-pdp-desktop"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('soi-pdp-gallery')) {
  customElements.define('soi-pdp-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.desktop = matchMedia('(min-width: 1000px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.layout = this.closest('.soi-pdp-layout');
      this.info = this.layout?.querySelector(':scope > .product__info');
      this.dialog = this.querySelector('dialog');
      this.videoHosts = [...this.querySelectorAll('[data-soi-video-host]')];
      this.onModeChange = this.updateMode.bind(this);
      this.desktop.addEventListener('change', this.onModeChange, { signal: this.signal });
      this.reducedMotion.addEventListener('change', this.onModeChange, { signal: this.signal });
      document.addEventListener('visibilitychange', () => this.syncVideos(), { signal: this.signal });
      window.addEventListener('resize', () => this.scheduleMeasure(), { passive: true, signal: this.signal });
      this.resizeObserver = new ResizeObserver(() => this.scheduleMeasure());
      if (this.info) this.resizeObserver.observe(this.info);
      this.resizeObserver.observe(document.documentElement);
      this.videoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => { entry.target.soiVisible = entry.isIntersecting; });
        this.syncVideos();
      }, { threshold: 0.15 });
      this.videoHosts.forEach(host => this.videoObserver.observe(host));
      this.addEventListener('click', event => this.onClick(event), { signal: this.signal });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('soi-pdp-zoom-open');
        this.syncVideos();
      }, { signal: this.signal });
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.showZoom(this.zoomIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, { signal: this.signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, { signal: this.signal });
      document.getElementById(this.dataset.formId)?.addEventListener('variant:changed', event => this.updateVariant(event.detail?.variant), { signal: this.signal });
      this.updateMode();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      this.videoObserver?.disconnect();
      cancelAnimationFrame(this.measureFrame);
      this.videoHosts?.forEach(host => host.querySelector('video')?.pause());
      if (this.dialog?.open) this.dialog.close();
    }
    updateMode() {
      if (this.desktop.matches) {
        this.videoHosts.forEach(host => {
          if (host.querySelector('video')) return;
          host.append(host.querySelector('template').content.cloneNode(true));
          const video = host.querySelector('video');
          video.muted = true;
          const toggle = host.querySelector('[data-soi-video-toggle]');
          if (toggle) toggle.hidden = false;
          ['play', 'pause'].forEach(name => video.addEventListener(name, () => this.updateToggle(host), { signal: this.signal }));
          video.addEventListener('error', () => {
            if (toggle) toggle.hidden = true;
            video.hidden = true;
          }, { signal: this.signal });
        });
      } else {
        this.info?.style.removeProperty('--soi-sticky-top');
        if (this.dialog.open) this.dialog.close();
      }
      this.syncVideos();
      this.scheduleMeasure();
    }
    syncVideos() {
      this.videoHosts.forEach(host => {
        const video = host.querySelector('video');
        if (!video) return;
        const visible = this.desktop.matches && host.soiVisible && !host.closest('[hidden]') && !document.hidden && !this.dialog.open;
        if (!visible) { video.pause(); return; }
        if (host.hasAttribute('data-soi-autoplay') && !host.soiPaused && (!this.reducedMotion.matches || host.soiUserPlayed)) video.play().catch(() => this.updateToggle(host));
      });
    }
    updateToggle(host) {
      const video = host.querySelector('video');
      const toggle = host.querySelector('[data-soi-video-toggle]');
      if (!toggle) return;
      toggle.setAttribute('aria-label', video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      toggle.querySelector('[data-soi-play-icon]').toggleAttribute('hidden', !video.paused);
      toggle.querySelector('[data-soi-pause-icon]').toggleAttribute('hidden', video.paused);
    }
    scheduleMeasure() {
      cancelAnimationFrame(this.measureFrame);
      this.measureFrame = requestAnimationFrame(() => {
        if (!this.desktop.matches || !this.info) return;
        const styles = getComputedStyle(document.documentElement);
        const number = name => parseFloat(styles.getPropertyValue(name)) || 0;
        const headerOffset = number('--header-height') * number('--enable-sticky-header') + number('--announcement-bar-height') * number('--enable-sticky-announcement-bar') + 20;
        const top = Math.max(headerOffset, this.layout.getBoundingClientRect().top + window.scrollY);
        this.info.style.setProperty('--soi-sticky-top', `${top}px`);
      });
    }
    updateVariant(variant) {
      if (!variant) return;
      const selectedId = String(variant.featured_media?.id || '');
      const tiles = [...this.querySelectorAll('[data-soi-media-id]')];
      tiles.forEach(tile => {
        const position = Number(tile.dataset.optionPosition);
        const option = String(variant.options?.[position - 1] || '').toLowerCase();
        tile.hidden = position > 0 && option !== tile.dataset.optionValue && tile.dataset.soiMediaId !== selectedId;
      });
      const first = tiles.find(tile => !tile.hidden && tile.dataset.soiMediaId === selectedId && tile.querySelector('[data-soi-zoom]')) || tiles.find(tile => !tile.hidden && tile.querySelector('[data-soi-zoom]'));
      tiles.forEach(tile => tile.classList.toggle('soi-pdp-tile--first', tile === first));
      this.syncVideos();
      this.scheduleMeasure();
    }
    onClick(event) {
      const toggle = event.target.closest('[data-soi-video-toggle]');
      if (toggle) {
        const host = toggle.closest('[data-soi-video-host]');
        const video = host.querySelector('video');
        if (!video) return;
        host.soiPaused = !video.paused;
        host.soiUserPlayed = true;
        if (host.soiPaused) video.pause();
        else video.play().catch(() => this.updateToggle(host));
        return;
      }
      const zoom = event.target.closest('[data-soi-zoom]');
      if (zoom && this.desktop.matches) {
        event.preventDefault();
        this.zoomItems = [...this.querySelectorAll('.soi-pdp-tile:not([hidden]) [data-soi-zoom]')];
        this.showZoom(this.zoomItems.indexOf(zoom));
        this.dialog.showModal();
        document.documentElement.classList.add('soi-pdp-zoom-open');
        this.syncVideos();
      }
      if (event.target.closest('[data-soi-zoom-close]')) this.dialog.close();
      if (event.target.closest('[data-soi-zoom-prev]')) this.showZoom(this.zoomIndex - 1);
      if (event.target.closest('[data-soi-zoom-next]')) this.showZoom(this.zoomIndex + 1);
    }
    showZoom(index) {
      this.zoomIndex = (index + this.zoomItems.length) % this.zoomItems.length;
      const link = this.zoomItems[this.zoomIndex];
      const image = new Image();
      image.alt = link.querySelector('img').alt;
      image.src = link.href;
      this.dialog.querySelector('.soi-pdp-zoom-image').replaceChildren(image);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soi-ring-size-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('soi-ring-size')) {
  customElements.define('soi-ring-size', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      customElements.whenDefined('drawer-content').then(() => {
        if (this.isConnected && this.controller) this.initialize();
      });
    }
    initialize() {
      this.source = this.closest('product-variants');
      this.form = document.getElementById(this.dataset.formId);
      this.drawer = document.getElementById(this.dataset.drawerId);
      if (!this.source || !this.form || !this.drawer) return;
      this.position = Number(this.dataset.position) - 1;
      this.variants = JSON.parse(this.querySelector('[data-size-variants]').textContent);
      this.trigger = this.querySelector('.soi-ring-size__trigger');
      this.formWrapper = this.closest('.product-form');
      this.statusSlot = this.querySelector('[data-size-status]');
      this.statusBlocks = [];
      this.source.classList.add('soi-ring-size-variants');
      this.formWrapper?.querySelectorAll('.shopify-app-block:has([data-stock-container]), product-inventory').forEach(status => {
        const placeholder = document.createElement('span');
        placeholder.hidden = true;
        status.before(placeholder);
        this.statusBlocks.push({ status, placeholder });
        this.statusSlot.append(status);
      });
      this.rows = Array.from(this.drawer.querySelectorAll('[data-size-value]'));
      this.confirmedValue = null;
      this.triggers = [this.trigger];
      this.nativeSelectors = [];
      const listen = (target, type, callback, capture = false) => target.addEventListener(type, callback, { capture, signal: this.controller.signal });
      document.querySelectorAll('product-variants').forEach(picker => {
        if (picker.getAttribute('form-id') !== this.dataset.formId) return;
        const input = picker.querySelector(`[name="option${this.position + 1}"]`);
        const native = input?.closest('[data-selector-type]');
        if (!native) return;
        this.nativeSelectors.push(native);
        native.classList.add('soi-size-native-hidden');
        if (picker !== this.source) {
          const mirror = this.trigger.cloneNode(true);
          native.before(mirror);
          this.triggers.push(mirror);
        }
      });
      this.source.querySelectorAll('[data-selector-type]').forEach(selector => {
        if (!selector.classList.contains('soi-size-native-hidden')) this.before(selector);
      });
      this.triggers.forEach(trigger => listen(trigger, 'click', () => this.openPicker(null, trigger)));
      listen(window, 'click', event => this.interceptClick(event), true);
      listen(window, 'submit', event => {
        if (event.target !== this.form || this.confirmedValue) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.openPicker(event.submitter || this.form.querySelector('[type="submit"]'));
      }, true);
      listen(this.form, 'variant:changed', () => this.syncVariant());
      listen(this.source, 'change', event => {
        if (!event.isTrusted || !event.target.name?.startsWith('option')) return;
        if (event.target.name !== `option${this.position + 1}`) {
          const changedPosition = Number(event.target.name.replace('option', '')) - 1;
          const compatible = this.variants.some(variant => variant.available && variant.options[this.position] === this.confirmedValue && variant.options[changedPosition] === event.target.value);
          if (!compatible) this.confirmedValue = null;
          queueMicrotask(() => this.syncVariant());
        }
      }, true);
      listen(this.drawer, 'click', event => {
        const row = event.target.closest('[data-size-value]');
        if (row && !row.disabled) this.choose(row.dataset.sizeValue);
        if (event.target.closest('[data-size-help]')) this.showHelp(true);
        if (event.target.closest('[data-size-back]')) this.showHelp(false);
      });
      listen(this.drawer, 'change', () => this.renderRows());
      listen(this.drawer, 'openable-element:close', () => {
        this.pendingButton = null;
        this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
      });
      this.form.classList.add('soi-size-awaiting');
      this.hidden = false;
      this.syncVariant();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.form?.classList.remove('soi-size-awaiting');
      this.formWrapper?.classList.remove('soi-size-confirmed');
      this.source?.classList.remove('soi-ring-size-variants');
      this.statusBlocks?.forEach(({ status, placeholder }) => {
        if (placeholder.isConnected) placeholder.replaceWith(status);
      });
      this.nativeSelectors?.forEach(native => native.classList.remove('soi-size-native-hidden'));
      this.triggers?.filter(trigger => trigger !== this.trigger).forEach(trigger => trigger.remove());
      if (this.drawer) {
        this.drawer.open = false;
        this.drawer.remove();
      }
    }
    interceptClick(event) {
      if (this.confirmedValue) return;
      const button = event.target.closest('button');
      if (!button || button.disabled) return;
      const isSubmit = button.type === 'submit' && button.form === this.form;
      const isBundle = button.id === 'AddToCartBundle' && button.closest('.product__info')?.contains(this);
      if (!isSubmit && !isBundle) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.openPicker(button);
    }
    selectedOptions() {
      const variant = this.variants.find(item => String(item.id) === this.form.elements.namedItem('id')?.value);
      return variant?.options || [];
    }
    matchingVariant(value) {
      const options = this.selectedOptions();
      return this.variants.find(variant => variant.options[this.position] === value && variant.options.every((option, index) => index === this.position || option === options[index]));
    }
    openPicker(button = null, trigger = null) {
      this.pendingButton = button;
      this.returnTrigger = trigger || this.trigger;
      this.showHelp(false, false);
      this.drawer.querySelector('[data-size-error]').hidden = true;
      this.renderRows();
      this.triggers.forEach(item => item.setAttribute('aria-expanded', 'true'));
      this.drawer.open = true;
    }
    showHelp(show, focus = true) {
      this.drawer.dataset.view = show ? 'help' : 'sizes';
      const main = this.drawer.querySelector('[data-size-page]');
      const guide = this.drawer.querySelector('[data-size-guide]');
      const back = this.drawer.querySelector('[data-size-back]');
      main.inert = show;
      main.setAttribute('aria-hidden', String(show));
      guide.inert = !show;
      guide.setAttribute('aria-hidden', String(!show));
      back.hidden = !show;
      const title = this.drawer.querySelector('.soi-size-drawer__title');
      title.textContent = show ? title.dataset.helpTitle : title.dataset.sizeTitle;
      if (focus) (show ? back : this.drawer.querySelector('[data-size-help]'))?.focus({ preventScroll: true });
    }
    usSize(circumference) {
      const measurements = [44.3,44.9,45.6,46.2,46.8,47.4,48.1,48.7,49.3,50,50.6,51.2,51.8,52.5,53.1,53.7,54.3,55,55.6,56.2,56.9,57.5,58.1,59.1,59.7,60.3,60.9,61.6,62.2,62.8,63.5,64.1,64.7,65.3,66,66.6,67.2,67.9,68.5,69.1,69.7,70.4,71];
      if (circumference < measurements[0] || circumference > measurements.at(-1)) return null;
      let nearest = 0;
      measurements.forEach((measure, index) => {
        if (Math.abs(measure - circumference) <= Math.abs(measurements[nearest] - circumference) + .00001) nearest = index;
      });
      return 3 + nearest * .25;
    }
    renderRows() {
      const us = this.drawer.querySelector('[data-size-system]').value === 'us';
      const diameter = this.drawer.querySelector('[data-size-measurement]').value === 'diameter';
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'de', { maximumFractionDigits: 2 });
      this.rows.forEach(row => {
        const value = row.dataset.sizeValue;
        const match = value.match(/^(\d{2}(?:[.,]\d+)?)(?=\s|$)/);
        const circumference = match ? Number(match[1].replace(',', '.')) : null;
        const converted = circumference ? this.usSize(circumference) : null;
        const numeric = circumference && circumference >= 40 && circumference <= 80;
        const suffix = numeric ? value.slice(match[0].length).trim() : '';
        const variant = this.matchingVariant(value);
        row.disabled = !variant?.available;
        row.setAttribute('aria-pressed', String(value === this.confirmedValue));
        row.querySelector('[data-size-label]').textContent = numeric ? (us && converted !== null ? formatter.format(converted) : match[1]) : value;
        row.querySelector('[data-size-note]').textContent = suffix;
        const stock = row.querySelector('[data-size-stock]');
        stock.textContent = !variant ? this.dataset.unavailable : !variant.available ? this.dataset.soldOut : variant.lastOne ? this.dataset.lastOne : '';
        stock.dataset.sizeStock = variant?.available && variant.lastOne ? 'last-one' : '';
        row.querySelector('[data-size-measure]').textContent = numeric ? `${formatter.format(diameter ? Math.round(circumference / Math.PI * 10) / 10 : circumference)} mm` : '';
      });
      this.drawer.querySelector('[data-size-conversion-note]').hidden = !us;
    }
    syncVariant() {
      const selected = this.selectedOptions()[this.position];
      if (this.confirmedValue && selected !== this.confirmedValue) this.confirmedValue = null;
      const label = this.confirmedValue ? this.dataset.selectedLabel.replace('[size]', this.confirmedValue) : this.dataset.findLabel;
      this.triggers.forEach(trigger => trigger.querySelector('[data-size-trigger-label]').textContent = label);
      this.form.classList.toggle('soi-size-awaiting', !this.confirmedValue);
      this.formWrapper?.classList.toggle('soi-size-confirmed', Boolean(this.confirmedValue));
      const options = this.selectedOptions();
      const anySizeAvailable = this.variants.some(variant => variant.available && variant.options.every((option, index) => index === this.position || option === options[index]));
      this.querySelector('[data-size-initial-status]').hidden = Boolean(this.confirmedValue && this.statusBlocks.length);
      this.querySelector('[data-size-initial-available]').hidden = !anySizeAvailable;
      this.querySelector('[data-size-initial-sold-out]').hidden = anySizeAvailable;
      this.renderRows();
    }
    async choose(value) {
      if (this.choosing) return;
      const variant = this.matchingVariant(value);
      if (!variant?.available) return;
      this.choosing = true;
      const pending = this.pendingButton;
      try {
        for (let attempt = 0; !this.source.product && attempt < 100; attempt++) await new Promise(resolve => setTimeout(resolve, 50));
        if (!this.isConnected || !this.source.product) throw Error('Variant selector not ready');
        this.confirmedValue = value;
        this.source.selectVariant(variant.id);
        if (this.form.elements.namedItem('id').value !== String(variant.id)) throw Error('Variant selection failed');
        this.syncVariant();
        this.drawer.open = false;
        if (pending?.isConnected && !pending.disabled) {
          pending.click();
        } else {
          this.returnTrigger?.focus({ preventScroll: true });
        }
      } catch {
        this.confirmedValue = null;
        this.syncVariant();
        const error = this.drawer.querySelector('[data-size-error]');
        error.textContent = this.dataset.error;
        error.hidden = false;
      } finally {
        this.choosing = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
